export var headers = {
	"Project-Id-Version": "open-xchange-appsuite-minimal-api-consent",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2017-02-22 13:42+0100",
	"Last-Translator": "Jöran Kuschel",
	Language: "en_US",
	"Language-Team": "NAME <EMAIL>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0"
};
export default {
	headers: headers
};
